<div class="header-bar mt-5 d-lg-flex flex-row-reverse justify-content-between w-100">
  <div class="justify-content-between d-flex pb-3 pb-lg-0 gap-2 align-items-center">
    @if (user() && user()!.secondaryOrganizations.length > 0) {
      <p-select
        [options]="getOrganizations()"
        [(ngModel)]="currentOrgId"
        (onChange)="changeOrganization($event.value)"
        optionValue="id"
        optionLabel="name">
      </p-select>
    } @else {
      <span class="align-middle pe-4 py-2">{{organizationName()}}</span>
    }

    @if (visibleNavItems().length > 0) {
      <div class="dropdown">
        <a data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" class="btn btn-nav">
          <span class="material-symbols-outlined text-primary" style="font-size: 22px;">
            tune
          </span>
        </a>
        <ul class="dropdown-menu dropdown-menu-end">
          @for (item of visibleNavItems(); track item) {
            @if (item.items) {
              @if (item.isVisible(user())) {
                <li>
                  <a class="dropdown-item d-flex align-items-center justify-content-between" role="button" data-bs-toggle="collapse"
                    [attr.data-bs-target]="'#' + item.title" [attr.aria-expanded]="item.expanded"
                    (click)="item.expanded = !item.expanded"
                    >
                    <span class="material-symbols-outlined text-primary me-1">
                      {{ item.icon}}
                    </span>
                    <span class="fw-normal me-2">{{ item.title | translate }}</span>
                    <span class="material-symbols-outlined transition float-end" [ngClass]="{'rotate-90': item.expanded}">
                      chevron_right
                    </span>
                  </a>
                  <div id="{{item.title}}" class="collapse" [ngClass]="{'show': item.expanded}">
                    @for (nestedItem of item.items; track nestedItem) {
                      @if (nestedItem.isVisible(user())) {
                        <a class="dropdown-item ps-4" [routerLink]="['/' + nestedItem.url]" routerLinkActive="current-page">
                          <span class="material-symbols-outlined text-primary me-1">
                            {{ nestedItem.icon}}
                          </span>
                          {{ nestedItem.title | translate }}
                        </a>
                      }
                    }
                  </div>
                </li>
              }
            }
            @else {
            @if (item.isVisible(user())) {
              <li>
                <a class="dropdown-item" [routerLink]="['/' + item.url]" routerLinkActive="current-page">
                  <span class="material-symbols-outlined text-primary me-1">
                    {{ item.icon }}
                  </span>
                  {{ item.title | translate }}
                </a>
              </li>
            }
          }
        }
      </ul>
    </div>
  }

  <div class="dropdown">
    <a data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" class="btn btn-nav d-flex align-items-center gap-1">
      <img [src]="profileImg" class="profile-img" />
      <div style="margin-left: 0.9rem;">
        <span [ngClass]="{'me-2': isImpersonating}" class="d-none d-sm-inline">
          {{ profileName() || ('profile' | translate) }}
        </span>
        @if (isImpersonating) {
          <span class="material-symbols-outlined" style="font-size: 22px;">
            swap_horiz
          </span>
        }
      </div>
    </a>
    <ul class="dropdown-menu dropdown-menu-end">
      <li><a class="dropdown-item" [routerLink]="['/profile']" [routerLinkActiveOptions]="{exact: true}"
      routerLinkActive="current-page">{{ 'profile' | translate }}</a></li>
      <li>
        <app-language-switcher></app-language-switcher>
      </li>
      @if (user()?.organization && canViewOrganizationSettings()) {
        <li>
          <a class="dropdown-item" [routerLink]="['/organizations', user()!.currentOrganization?.id ?? user()!.organization!.id, 'settings']" [routerLinkActiveOptions]="{exact: true}"
          routerLinkActive="current-page">{{ 'organizations.settings' | translate }}</a>
        </li>
      }
      <li><a class="dropdown-item" [routerLink]="['/profile/sessions']" [routerLinkActiveOptions]="{exact: true}"
      routerLinkActive="current-page">{{ 'sessions' | translate }}</a></li>
      @if (!isImpersonating) {
        <li><a class="dropdown-item" (click)="logout()">{{ 'logout' | translate }}</a></li>
      }
      @if (isImpersonating) {
        <li><a class="dropdown-item" (click)="endImpersonation()">{{ 'end_impersonation' | translate }}</a></li>
      }
    </ul>
  </div>
</div>

@if (impersonationSessionEnded) {
  <div class="alert alert-warning d-flex align-items-center justify-content-between p-3 position-relative"
    role="alert">
    <div class="d-flex align-items-center gap-2">
      <span class="material-symbols-outlined">warning</span>
      <span>{{ 'Your impersonation session has ended.' | translate }}</span>
    </div>
    <button type="button" class="btn-close btn-sm" aria-label="Close"
    (click)="dismissImpersonationEndedWarning()"></button>
  </div>
}

<h1 class="d-flex flex-row align-items-baseline gap-2">
  @if (backRoute) {
    <a [routerLink]="[backRoute]"><span class="material-symbols-outlined fs-1">arrow_back</span></a>
  } @else if (showDefaultBackButton) {
    <a (click)="navigateBack()"><span class="material-symbols-outlined fs-1">arrow_back</span></a>
  }
  @if (autoTranslateTitle) {
    <span>{{title | translate}}</span>
  } @else {
    <span>{{title}}</span>
  }
</h1>
</div>
@if (date !== undefined) {
  <div class="date mt-2 mb-2">{{date | ordinalDate }}</div>
}

<app-maintenance-info></app-maintenance-info>
